import React from 'react';
import './ConfirmButton.scss';

const COLOR_PRESETS = {
  green: {
    active: {
      background: 'linear-gradient(135deg, #057036, #51BA62)',
      border: 'linear-gradient(132.38deg, #ABECB0, #16570A)',
      textColor: '#FFFFFF',
      boxShadow: '4px 4px 18px 0px #BEDEC3',
    },
    disabled: {
      background: 'linear-gradient(135deg, #F2F2F2, #F2F2F2)',
      border: 'linear-gradient(132.38deg, #FAFAFA, #E4E8E5)',
      textColor: '#A7ABA8',
      boxShadow: 'none',
    },
  },
  orange: {
    active: {
      background: 'linear-gradient(135deg, #E07020, #F5A623)',
      border: 'linear-gradient(132.38deg, #FFD9B3, #C45C10)',
      textColor: '#FFFFFF',
      boxShadow: '4px 4px 18px 0px #FFE4C9',
    },
    disabled: {
      background: 'linear-gradient(135deg, #FDF5EE, #FDF5EE)',
      border: 'linear-gradient(132.38deg, #FFF7F0, #F5E0D0)',
      textColor: '#C9A88A',
      boxShadow: 'none',
    },
  },
  blue: {
    active: {
      background: 'linear-gradient(135deg, #1E5FAA, #4A90D9)',
      border: 'linear-gradient(132.38deg, #B3D4FC, #0D4A8A)',
      textColor: '#FFFFFF',
      boxShadow: '4px 4px 18px 0px #C9DFFB',
    },
    disabled: {
      background: 'linear-gradient(135deg, #F0F5FA, #F0F5FA)',
      border: 'linear-gradient(132.38deg, #F5F9FF, #D0DEE8)',
      textColor: '#8AA8C9',
      boxShadow: 'none',
    },
  },
  purple: {
    active: {
      background: 'linear-gradient(135deg, #7B2D8E, #A855C4)',
      border: 'linear-gradient(132.38deg, #E0B3F0, #5A1A6E)',
      textColor: '#FFFFFF',
      boxShadow: '4px 4px 18px 0px #E8D4F0',
    },
    disabled: {
      background: 'linear-gradient(135deg, #F8F0FA, #F8F0FA)',
      border: 'linear-gradient(132.38deg, #FBF5FF, #E0D0E8)',
      textColor: '#B08AC9',
      boxShadow: 'none',
    },
  },
  black: {
    active: {
      background: 'linear-gradient(107.74deg, #2C2C2C 27.91%, #6D6767 98.01%)',
      border: 'linear-gradient(90deg, #2C2C2C 0%, #999999 100%)',
      textColor: '#FFFFFF',
      boxShadow: '4px 4px 18px 0px rgba(44, 44, 44, 0.3)',
    },
    disabled: {
      background: 'linear-gradient(135deg, #E8E8E8, #E8E8E8)',
      border: 'linear-gradient(132.38deg, #F0F0F0, #D0D0D0)',
      textColor: '#A0A0A0',
      boxShadow: 'none',
    },
  },
};

const ConfirmButton = ({
  text = 'ยืนยันคำตอบ',
  width = undefined,
  disabled = false,
  color = 'green',
  onClick = () => {},
}) => {
  const preset = COLOR_PRESETS[color] || COLOR_PRESETS.green;
  const colorStyle = disabled ? preset.disabled : preset.active;

  return (
    <div
      className={`confirm-button-container${disabled ? ' confirm-button-disabled' : ''}`}
      onClick={!disabled ? onClick : undefined}
      style={{
        ...(width && { width }),
        background: `${colorStyle.background} padding-box, ${colorStyle.border} border-box`,
        boxShadow: colorStyle.boxShadow,
      }}
    >
      <div className="confirm-button-text" style={{ color: colorStyle.textColor }}>
        {text}
      </div>
    </div>
  );
};

export default ConfirmButton;
